import React from 'react';

import { Email } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  activityTemplates,
  AuthWrapper,
  DeleteAccountModal,
  ProfileSection
} from 'modules';

import * as dataService from './dataService';
import { EditAccountSection } from './EditAccountSection/EditAccountSection';
import { EditProfileSection } from './EditProfileSection/EditProfileSection';



const ButtonGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end'
}));

const EmailBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: theme.spacing(2)
}));

const EmailTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: '#528898'
}));

export interface IUserProfileActivityProps {}

export const UserProfileActivity: React.FC<IUserProfileActivityProps> = props => {
  const { data } = dataService.useUserProfileActivity();



  return (
    <AuthWrapper.FC superAdminOnly>
      <activityTemplates.SuperAdminActivityTemplate.FC>
        <Grid
          container
          spacing={15}>
          <Grid
            item
            xs={5}>
            <Card
              variant="outlined"
              elevation={0}>
              <CardContent>
                <Stack alignItems="center">
                  <Typography variant="h1">
                    {data.fullName}
                  </Typography>

                  <EmailBox>
                    <Email style={{ color: '#528898' }} />

                    <EmailTypography>
                      {data.email}
                    </EmailTypography>
                  </EmailBox>
                </Stack>

              </CardContent>
            </Card>
          </Grid>

          <Grid
            container
            item
            xs={7}
            spacing={5}>
            <Grid
              item
              xs={12}>
              <ProfileSection.FC title="Edit Your Profile">
                <EditProfileSection />
              </ProfileSection.FC>
            </Grid>

            <Grid
              item
              xs={12}>
              <ProfileSection.FC title="Edit Your Account Settings">
                <EditAccountSection />
              </ProfileSection.FC>
            </Grid>

            <ButtonGrid
              item
              xs={12}>
              <DeleteAccountModal.FC />
            </ButtonGrid>
          </Grid>
        </Grid>
      </activityTemplates.SuperAdminActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
